<template>
    <section>
        <el-popover
            placement="bottom-end"
            width="480"
            trigger="click"
            v-model="visible">
            <div class="column_group">
                <!-- <div class="fw-w f">
                    <div class="myColumn f--c pointer">
                        <el-checkbox :value="true" :disabled="true">平台/店铺</el-checkbox>
                    </div>
                    <div class="myColumn f--c pointer">
                        <el-checkbox :value="true" :disabled="true">kaka订单号</el-checkbox>
                    </div>
                    <div class="myColumn f--c pointer">
                        <el-checkbox :value="true" :disabled="true">商品信息</el-checkbox>
                    </div>
                </div> -->
                <div class="fw-w f" id="column_group_9387482934">
                    <div class="myColumn f--c pointer">
                        <el-checkbox :value="true" :disabled="true">kaka订单号</el-checkbox>
                    </div>
                    <div class="myColumn f--c pointer">
                        <el-checkbox :value="true" :disabled="true">商品信息</el-checkbox>
                    </div>
                    <div class="myColumn f--c pointer" v-for="(item) in allColumns" :key="item.label">
                        <el-checkbox v-model="item.checked">{{item.label}}</el-checkbox>
                    </div>
                </div>
            </div>
            <div class="f-c-c">
                <el-button type="primary" style="width: 200px;" @click="submit">确定</el-button>
            </div>
            <el-button slot="reference" @click="init">列表字段配置</el-button>
        </el-popover>
    </section>
</template>

<script>
import API from '@/api'
import Sortable from 'sortablejs'

export default {
    props: {
        columnInfo: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            allColumns: [
                '平台/店铺',
                '商标名称',
                '总金额',
                // '平台付款时间',
                // '用户邮箱',
                '创建时间',
                '付款时间',
                '订单状态',
                '第三方平台单号',
                '第三方支付单号',
                'Payment ID',
                '优惠码',
                '推广码',
                '物流渠道编码',
                '渠道名称',
                '物流等级',
                '收货人',
                '收货国家',
                '省州',
                '城市',
                '地址信息1',
                '地址信息2',
                '邮编',
                '电话',
                '邮箱/手机号',
                '订单总金额',
                '优惠码金额',
                '优惠券金额',
                '运费',
                '折扣总金额',
                'SKU重量',
                '买家留言'
            ],
            visible: false
        }
    },
    created() {
        this.allColumns = this.allColumns.map(e=>({checked: false, label: e}))
    },
    methods: {
        init() {
            this.$nextTick(()=>{
                const el = document.getElementById('column_group_9387482934')
                const that = this
                Sortable.create(el, {
                    animation: 500,
                    delay: 0,
                    dataIdAttr: 'data-id',
                    onEnd: ({ oldIndex, newIndex }) => {
                        that.allColumns.splice(newIndex, 0, ...that.allColumns.splice(oldIndex, 1))
                    }
                })
            })
        },
        submit() {
            this.visible = false
            // '平台/店铺', 'kaka订单号', '商品信息'
            const showColumns = [ ...this.allColumns.filter(e=>e.checked).map(e=>e.label)]
            this.setBehaviorConfig()
            this.$emit('submit', showColumns)
        },
        setBehaviorConfig() {
            const params = {
                type: 1,
                content: JSON.stringify([ ...this.allColumns.filter(e=>e.checked).map(e=>e.label)]),
                id: this.columnInfo.id || undefined
            }
            API.setBehaviorConfig(params)
        },
        setShowColumn(arr) {
            this.allColumns.forEach(e=>{
                if(arr.includes(e.label)) e.checked = true
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.column_group{
    padding: 0 10px 10px;
    max-height: 800px;
    overflow-y: scroll;
    width: 480px;
}
#column_group_9387482934{
}
.myColumn{
    padding: 8px 12px;
    border: 1px solid #EBEEF5;
    margin-bottom: 10px;
    width: 140px;
    margin-right: 10px;
}
</style>